import { ExpressPolicyChanges } from '../../../src/components'
import Footer from '../../../src/components/Footer'
import Header from '../../../src/components/Header'

export default function Index() {
  return (
    <div className="cure-inner-container">
      <ExpressPolicyChanges />
    </div>
  )
}
